import { useState } from 'react';
import useApi from 'services/mavapi/useApi';
import {
  DashboardService,
  GeneralLookup,
  SummaryTotal,
  TopRider,
  UpcomingShow,
} from 'services/openapi';

export const useDashboardApi = () => {
  const {
    dashboardGetUpcomingShows,
    dashboardGetTotalSummary,
    dashboardGetTopRiders,
    dashboardGetUserShows,
  } = DashboardService;
  const [, setError] = useState<unknown | null>();
  const { handleRequest } = useApi();
  const [isLoading, setIsLoading] = useState(true);
  const [upcompingLoading, setUpcomingLoading] = useState(true);
  const [summaryLoading, setSummaryLoading] = useState(true);
  const [upcomingShows, setUpcomingShows] = useState<UpcomingShow[]>([]);
  const [totalSummary, setTotalSummary] = useState<SummaryTotal | null>(null);
  const [topRiders, setTopRiders] = useState<TopRider[]>([]);
  const [userShows, setUserShows] = useState<GeneralLookup[]>([]);
  const getUpcomingShows = () => {
    setUpcomingLoading(true);
    handleRequest(dashboardGetUpcomingShows())
      .then(res => {
        setUpcomingShows(res);
      })
      .catch(err => {
        setError(err);
      })
      .finally(() => {
        setUpcomingLoading(false);
      });
  };
  const getTotalSummary = () => {
    setSummaryLoading(true);
    handleRequest(dashboardGetTotalSummary())
      .then(res => {
        setTotalSummary(res);
      })
      .catch(err => {
        setError(err);
      })
      .finally(() => {
        setSummaryLoading(false);
      });
  };
  const getTopRiders = (showId?: string) => {
    setIsLoading(true);
    handleRequest(dashboardGetTopRiders(showId))
      .then(res => {
        setTopRiders(res);
      })
      .catch(err => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const getUserShows = () => {
    handleRequest(dashboardGetUserShows())
      .then(res => {
        setUserShows(res);
      })
      .catch(err => {
        setError(err);
      });
  };
  return {
    getUpcomingShows,
    upcomingShows,
    getTotalSummary,
    totalSummary,
    getTopRiders,
    topRiders,
    getUserShows,
    userShows,
    isLoading,
    upcompingLoading,
    summaryLoading,
  };
};
